import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InvoiceDocumentsFeatureState, invoiceDocumentsAdapter } from './invoice-document.reducer';

export const selectInvoiceDocumentsFeature =
  createFeatureSelector<InvoiceDocumentsFeatureState>('invoiceDocuments');

createSelector(
  selectInvoiceDocumentsFeature,
  (s) => s.list, // <-- this is EntityState<Overview>
);

const selectInvoiceDocsByIdSlice = createSelector(
  selectInvoiceDocumentsFeature,
  (s) => s.byId, // <-- this is EntityState<Detail>
);

const byIdSelectors = invoiceDocumentsAdapter.getSelectors(selectInvoiceDocsByIdSlice);

export const selectInvoiceDocumentEntities = byIdSelectors.selectEntities;

export const selectInvoiceDocumentById = (id: number | string) =>
  createSelector(selectInvoiceDocumentEntities, (entities) => entities[id]);
